// Every logging method, on the Today page, one tap from the summary.
//
// Two earlier shapes were rejected: a single "Log food" pill that opened a
// chooser (two taps to a method that was never in doubt), and three tiles plus
// a "More" sheet (still hid four methods behind a modal). This shows all of
// them, which is what the app is for.
//
// A grid rather than a horizontal scroller, deliberately: the date strip
// proved that a scroller inside a tab-swiping page steals the gesture at its
// scroll boundary. Four fitted columns wrap to a second row instead, so every
// method is visible without a single pixel of overflow.
import { LOG_OPTIONS, type LogMethod } from "../lib/logMethods";
import { canScanBarcode } from "../lib/barcode";
import { hapticTap } from "../lib/haptics";
import { useT } from "../lib/i18n";

export function LogMethodRow(
  // No badge, no lock, no chip on any tile (owner decision): every method
  // looks the same on the surface, and tapping a Premium one simply opens
  // the paywall. The gate lives in the tap handler, not in the visuals.
  { onPick }: { onPick: (m: LogMethod) => void },
) {
  const t = useT();
  const options = LOG_OPTIONS.filter((o) => o.method !== "barcode" || canScanBarcode());

  return (
    <div className="grid grid-cols-4 gap-2">
      {options.map(({ method, icon: Icon, tint, short }) => (
        <button
          key={method}
          type="button"
          onClick={() => { hapticTap(); onPick(method); }}
          className="relative min-h-[4.5rem] glass rounded-2xl flex flex-col items-center justify-center gap-1.5 px-1 press"
        >
          <span
            aria-hidden="true"
            className="w-9 h-9 rounded-xl flex items-center justify-center shrink-0"
            style={{ background: tint }}
          >
            <Icon size={19} strokeWidth={2.2} className="text-black/80" />
          </span>
          <span className="text-sm font-medium leading-tight truncate w-full text-center">
            {t(short)}
          </span>
        </button>
      ))}
    </div>
  );
}
